<h2 class="govuk-visually-hidden">Support links</h2>
<ul class="govuk-footer__inline-list">
  <ng-content></ng-content>
</ul>
